module.exports = __webpack_public_path__ + "static/media/28DGC2.6cc783c4.jpg";